import { CSSProperties } from 'react';

export const mobileBookingCardHeight = 230;

export const mobileBookingCardStyle: CSSProperties = {
  height: `${mobileBookingCardHeight}px`,
};
